<template>
	<!-- 查看弹窗 -->
	<div v-if="viewData&&viewData.isShow">
	    <div class="mask check-log" v-if="!isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">View <i class="e-modal-close" @click="viewData.isShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table" cellspacing="0">
	                    <tr>
	                        <td>SN</td>
	                        <td>Purchase order</td>
	                        <td>Bank</td>
	                        <td>Card</td>
	                        <td>Price</td>
	                        <td>Date</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in list">
	                   	<tr>
	                    	<td>{{index+1}}</td>
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupBankName}}</td>
	                        <td>{{item.SupBankAccount}}</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6" v-if="!isPdf(item.EevidenceImg)">
	                    		<img style="width:1100px;" :src="item.EevidenceImg">
	                    	</td>
												<td colspan="6" v-if="isPdf(item.EevidenceImg)">
													<div :ref="'pdfBox' + index" class="pdf-box">
														<span v-if="pdfLoading">loading...</span>
													</div>
												</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6">
	                    		<div class="review-details-btn" @click="showDetails(item)">
	                    			View payment details
	                    		</div>
	                    	</td>
	                    </tr>
	                    </tbody>
	                    <tr v-if="!list||list.length<=0">
	                    	<td colspan="7">No relevant data</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>


	    <div class="mask check-log" v-if="isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">Payment details <i class="e-modal-close" @click="isDetailsShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table " cellspacing="0">
	                    <tr>
	                        <td>Purchase order</td>
	                        <td>Hotel</td>
	                        <td>Guest</td>
	                        <td>Bank/Card</td>
	                        <td>Price</td>
	                        <td>Date</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in detailsList">
	                   	<tr>
	                    	
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupName}}</td>
	                        <td>{{item.Guests}}</td>
	                        <td>
	                        	{{item.SupBankName}}</br>
	                        	{{item.SupBankAccount}}
	                    	</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>

	                    </tr>
	             
	                    </tbody>

	                    <tr v-if="!detailsList||detailsList.length<=0">
	                    	<td colspan="7">No relevant data</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>



    </div>
</template>
<script>
export default {
	name: 'paymentView',
	props:{
        vdata: {
            type: Object,
 						default: function(){
                return {}
            }
        }
  	},
  	data(){
  		return {
  			viewData:{},
  			list:[],
  			detailsList:[],
  			isDetailsShow:false,
				pdfLoading: false,
				falg:true
  		}
  	},
  	watch:{
			vdata(val) {
				this.viewData=val;
				this.initData();
			},
  		'vdata.isShow'(val) {
				var that = this
				if (val&&that.list.length>0) {
					that.$nextTick(() => {
						that.list.forEach((item, idx) => {
							if (that.isPdf(item.EevidenceImg)) {
								const boxArr = that.$refs['pdfBox' + idx]
								const box = boxArr && boxArr[0]
								if (box) that.renderPdf(item.EevidenceImg, box)
							}
						})
					})
				}
			}
  	},
  	methods:{
			isPdf(fileName) {
				// fileName = 'https://pic.cnbooking.net//uploadorder//202512//2025121210720067370852.pdf'
				if (!fileName) return false
				return /\.pdf$/i.test(fileName.split('?')[0])
			},
			renderPdf(url, box) {
				if (!url) return
				this.pdfLoading = true
				const pdfjsLib = require('pdfjs-dist')
				pdfjsLib.GlobalWorkerOptions.workerSrc =
					'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.min.js'

				pdfjsLib.getDocument(url).promise.then(pdf => {
					const tasks = []
					for (let i = 1; i <= pdf.numPages; i++) {
						tasks.push(
							pdf.getPage(i).then(page => {
								const viewport = page.getViewport({ scale: 1.5 })
								const canvas = document.createElement('canvas')
								const ctx = canvas.getContext('2d')
								canvas.height = viewport.height
								canvas.width = viewport.width
								box.appendChild(canvas)   // 这里保证 box 是原生 DOM
								return page.render({ canvasContext: ctx, viewport }).promise
							})
						)
					}
					return Promise.all(tasks)
				}).then(() => {
					this.pdfLoading = false
				}).catch(err => {
					this.pdfLoading = false
					console.error('PDF 渲染失败', err)
				})
			},

  		showDetails(item){
			
					var that=this;
					that.isDetailsShow=true;
	        var params={
	          paymentid: item.PaymentID
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByPaymentID,
	            params: params
	        }).then(res => {
	        	
	        	if(res&&res.Result.length>0){
	        		this.detailsList = res.Result;
	        	}else{
	        		this.detailsList = [];
	        	}
	        });
			
  		},
  		initData(){
					var that=this;
					if(!that.falg) return
					that.falg = false
					that.list = [];
					that.detailsList = [];
					that.pdfLoading = false;
	        var params={
	          supOrderNO: that.viewData.MainOrderId
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByOrderNO,
	            params: params
	        }).then(res => {
						that.falg = true
	        	if(res&&res.Result.length>0){
	        		that.list=res.Result||[]
							that.$nextTick(() => {
								that.list.forEach((item, idx) => {
									if (that.isPdf(item.EevidenceImg)) {
										const boxArr = that.$refs['pdfBox' + idx]
										const box = boxArr && boxArr[0]
										if (box) that.renderPdf(item.EevidenceImg, box)
									}
								})
							})
							
	        	}else{
	        		// that.error({ title: '提示', content: '没有查询到相关数据' });
	        	}
	        });
  		}

  	}


}
</script>


// WEBPACK FOOTER //
// src/components/payment/paymentView.vue